import { Taxonomy } from "@common/categories";
import { Category } from "@common/types/category";

export const NON_BUSINESS_TAXONOMIES: Taxonomy[] = [
    Taxonomy.personal,
    Taxonomy.transfer,
];

/**
 * Whether a category is a custom business subcategory whose per-entity GL grid
 * can be shown — the create flow only customizes business parents, and only
 * subcategories (not top-level categories) carry an editable GL mapping.
 */
export function isCustomBusinessSubcategory(category: Category): boolean {
    return (
        category.isBusiness &&
        !NON_BUSINESS_TAXONOMIES.includes(category.taxonomy) &&
        category.parentCategoryId != null
    );
}
